import {updateProgress} from 'modules/user/actions/progress';

export const codeChallengeProgressToAPI = ({
  id,
  completed,
  is_help_used,
  callback,
}) => {
  const data = {
    is_help_used: !!is_help_used,
    id,
  };
  if (completed) data.status = 'completed';
  return {
    types: [
      'UPDATE_CODECHALLENGE_PROGRESS_REQUEST',
      'UPDATE_CODECHALLENGE_PROGRESS_SUCCESS',
      'UPDATE_CODECHALLENGE_PROGRESS_FAILURE',
    ],
    config: {
      url: 'school/user-progress-code-challenges/',
      method: 'POST',
      data,
    },
    payload: {stepId: id, completed},
    callback,
    loadingBar: false,
  };
};

export const updateCodeChallengeProgress = ({
  id,
  completed,
  is_help_used,
  related_steps,
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const currentProgress =
      (state.user.progress.step && state.user.progress.step[id]) ||
      'not started';
    if (
      currentProgress !== 'completed' &&
      (currentProgress === 'not started' || completed)
    ) {
      dispatch(
        codeChallengeProgressToAPI({
          id,
          completed,
          is_help_used,
          callback: (success) => {
            if (success)
              dispatch(updateProgress({id, completed, related_steps}));
          },
        }),
      );
    }
  };
};

export default updateCodeChallengeProgress;
